import { Box } from "@mui/material";
import React from "react";
import { Button, Modal, Form } from "react-bootstrap";
import { FaTimes } from "react-icons/fa";

const Rename = ({
  title,
  showmodal,
  handleClose,
  handleSubmit,
  Name,
  setName,
}) => {
  return (
    <Modal
      show={showmodal}
      onHide={() => {
        handleClose();
      }}
      backdrop="static"
      keyboard={false}
      className="modal-dialog-centered"
    >
      <Modal.Header className="bg-white border-b border-gray-300">
        {/* <div class="p-3 mb-2 bg-warning text-dark">File name already exists. Copy or Replace</div> */}
        <div className="text-xl font-semibold text-gray-600">{title}</div>
        <Button
          variant="light"
          onClick={() => handleClose()}
          className="ml-auto bg-transparent text-gray-700 hover:text-gray-900 p-2 rounded-full"
        >
          <FaTimes color="gray" />
        </Button>
      </Modal.Header>
      <Modal.Body className="p-6 overflow-auto">
        <Form>
          <Box
            component="form"
            sx={{
              "& .MuiTextField-root": { m: 1 },
            }}
            noValidate
            autoComplete="off"
          >
            <div className="flex mb-3">
              <div className="flex-1 mr-2">
                <input
                  type="text"
                  placeholder="Filename"
                  value={Name}
                  onChange={(e) => setName(e.target.value)}
                  className="form-control"
                />
              </div>
            </div>
            {/* <div className="flex mb-3">
    <div className="flex-1 mr-2">
      <TextField
        label="Filename"
        value={fileContent.name}
        InputProps={{
          readOnly: false,
        }}
        variant="outlined"
        size="small"
        fullWidth
      />
    </div>
  </div> */}
          </Box>
        </Form>
      </Modal.Body>
      <Modal.Footer className="bg-gray-200 border-t border-gray-300 flex justify-end">
        <Button
          variant="primary"
          onClick={() => {
            handleSubmit();
            handleClose();
            // Implement the copy functionality here
          }}
          className="mr-2"
        >
          rename
        </Button>
      </Modal.Footer>
    </Modal>
  );
};

export default Rename;
